import React, { useState } from "react";
import "./App.css";
import axios from "axios";

function App() {
  const [images, setImages] = useState([]);
  const [inputValue, setInputValue] = useState("");
  const [pageValue, setPageValue] = useState("1");

  const getImage = () => {
    axios
      .get(
        `https://api.unsplash.com/search/photos?page=${pageValue}&query=${inputValue}&client_id=i3yxrah6kf_3zlUfzZOW0h2RztGayiSwkWs8dKgPqLA`
      )
      .then((res) => {
        setImages(res.data.results);
      })
      .catch((error) => {
        console.log("Error fetching images:", error);
      });
  };

  const handleInputChange = (e) => {
    setInputValue(e.target.value);
  };
  const pageInputChange = (e) => {
    setPageValue(e.target.value);
  };

  return (
    <>
      <div class="heading">
        <h1> Pexels Image World With React API </h1>{" "}
      </div>{" "}
      <div className="item">
        <input
          type="number"
          name="inputvalue"
          value={pageValue}
          onChange={pageInputChange}
          placeholder="enter page number"
          className="page"
        />{" "}
        <input
          type="text"
          name="inputvalue"
          value={inputValue}
          onChange={handleInputChange}
          placeholder="search"
        />{" "}
        <button className="btn btn-primary" onClick={getImage}>
          search{" "}
        </button>{" "}
      </div>{" "}
      <div className="container">
        {" "}
        {images.map((value, index) => {
          return (
            <div key={index} className="img-container">
              <img src={value.urls.small} alt="images" />
            </div>
          );
        })}{" "}
      </div>{" "}
    </>
  );
}

export default App;
